var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.36842 2.57895V2.57895C3.36842 1.70692 4.07534 1 4.94737 1H14C15.1046 1 16 1.89543 16 3V11.6316C16 12.7361 15.1046 13.6316 14 13.6316H13.6316",
    stroke: "#0B3C88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6313 4.57892C13.6313 3.47435 12.7359 2.57892 11.6313 2.57892H2.99977C1.8952 2.57892 0.999768 3.47435 0.999768 4.57892V7.68418C0.999768 8.78875 1.8952 9.68418 2.99977 9.68418H4.52609C5.63066 9.68418 6.52608 10.5796 6.52608 11.6842V13.2105C6.52608 14.3151 7.42151 15.2105 8.52608 15.2105H11.6313C12.7359 15.2105 13.6313 14.3151 13.6313 13.2105V4.57892Z",
    stroke: "#0B3C88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10547 15.2105V15.2105C7.09449 15.2105 6.12491 14.8089 5.41004 14.0941L2.11669 10.8007C1.40182 10.0858 1.00021 9.11627 1.00021 8.10529V8.10529",
    stroke: "#0B3C88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.1f0f6324036e35cedd98d5a339d9c0cd.svg";
export { ForwardRef as ReactComponent };